import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/vsts/work/1/s/src/gmp-swa/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/home/vsts/work/1/s/src/gmp-swa/layouts/error.vue").then(m => m.default || m)),
  fullscreen: defineAsyncComponent(() => import("/home/vsts/work/1/s/src/gmp-swa/layouts/fullscreen.vue").then(m => m.default || m))
}